export default "__VITE_ASSET__CkoapGvz__"